export default function convertFuelConsumptionInT(fuelConsumptionInM3: number, density: number) {
  return (fuelConsumptionInM3 * density) / 1000
}
